module.exports = __webpack_public_path__ + "static/media/img2-3.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/biosense/diff/img2-3.png
// module id = 1981
// module chunks = 3